import * as React from "react";
import PropTypes from 'prop-types';
import SwipeableViews from "react-swipeable-views";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import withStyles from "@material-ui/core/styles/withStyles";
import { primaryColor } from "../../assets/jss/material-dashboard-pro-react.jsx";

function TabContainer(props) {
  return (
    <div className='tab-container'>{props.content}</div>
  );
}

TabContainer.propTypes = {
  content: PropTypes.node.isRequired
};

const fullWidthTabsStyle = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: primaryColor,
  },
  tabButtonColor: primaryColor,
});

class FullWidthTabs extends React.Component {

  constructor(props) {
    super(props);
  
    this.state = {
      value: 0
    };
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  }

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  }
  renderTabButtons() {
    const { classes } = this.props;
    return (
      <Tabs
        value={this.state.value}
        onChange={this.handleChange}
        variant="fullWidth"
        classes={{
          indicator: classes.indicator
        }}>
      >
        {this.props.tabs.map((t, i) => <Tab key={i} style={{color: primaryColor}} className={this.props.tabButtonClassName} label={t.tabButton} />)}
      </Tabs>
    );
  }

  renderTabContent() {
    return (
      <SwipeableViews
        className={this.props.tabContent}
        axis={'x'}
        index={this.state.value}
        onChangeIndex={this.handleChangeIndex}
      >
        {this.props.tabs.map((t, i) => <TabContainer key={i} content={t.tabContent} />)}
      </SwipeableViews>
    );
  }

  render() {

    const { classes } = this.props;

    return (
      <div className={this.props.className}>
        <AppBar position="static" className={this.props.headerClassName}>
            {this.renderTabButtons()}
        </AppBar>
        {this.renderTabContent()}
      </div>
    );
  }
}

export default withStyles(fullWidthTabsStyle)(FullWidthTabs);